import { FC } from 'react';

import { Error } from '@ui/Error';

export const ErrorPage: FC = () => (
  <>
    <Error />
  </>
);
